<template>
    <div>
        <p class="footer">Copyright © 2020 OneShop All Rights Reserved. POWERED BY ONESHOP</p>
    </div>
</template>

<script>
    export default {
        
    }
</script>

<style lang="less" scoped>
.footer {
    height: 14px;
    font-size: 12px;
    font-family: PingFangSC-Regular, PingFang SC;
    font-weight: 400;
    color: rgba(170, 178, 192, 1);
    line-height: 14px;
    text-align: center;
    margin: 16px 0;
  }
</style>